<template>
<div class="tab-inner-left">
  <div class="form-module">
    <h2>Data Collection</h2>
    <p>Select the types of data you want to collect from the campaign.</p>
    <span v-show="errors.has('option')" class="text-danger">{{ errors.first('option') }}</span>
    <div class="field-option" v-for="(option, option_index) in fieldnames" :key="option_index">
      <label>
        <input type="checkbox"
               :value="option.code"
               :checked="fieldList.includes(option.code)"
               :disabled="option.code === 'email'"
               @change="onCheckChange(option, $event)"
               ref="option" name="option" data-vv-name="option"
               v-validate="(fieldList.length === 0) ? 'required' : ''">
        {{ option.name }}
      </label>
    </div>
  </div>
  <div class="form-module" v-if="customFieldList.length > 0">
    <h2>Custom Inputs</h2>
    <p>Create any data field you want to collect from the campaign.</p>
    <custom-field-item v-for="(field_item, index) in customFieldList" :key="index" :field="field_item" :ref="`customfield${index}`" :updated="update_data" />
  </div>
  <label class="al-button" @click="customFieldList.push(customField)">
    <i class="fas fa-plus"></i> Add a Custom Field
  </label>
</div>
</template>

<script>
import CustomFieldItem from './CustomFieldItem'
export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      create: true,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      name: '',
      logo_id: '',
      title: '',
      offer: '',
      campaign_image_id: '',
      customField: {
        name: '',
        type: 'text',
        code: 'name',
        value: true
      },
      customFieldList: [],
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: true
        },
        {
          name: 'Your Website',
          code: 'website',
          type: 'website',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: [],
      prizeList: [],
      prizeDefault: {
        name: '',
        image_id: ''
      },
      campaign_name_focused: false,
      campaign_slogan_focused: false,
      campaign_award_focused: false
    }
  },
  components: {
    CustomFieldItem
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    campaign_name_focused () {
      this.update_data()
    },
    dataVal () {
      this.set_data()
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    }
  },
  methods: {
    onCheckChange (option, e) {
      console.log('check change')
      console.log(e.target.value)


      const index = this.fieldList.findIndex(x => x === e.target.value)
      //const name_index = this.fieldnames.findIndex(x => x === e.target.value)
      // here you can check specific property for an object whether it exist in your array or not

      index === -1 ? this.fieldList.push(e.target.value) : this.fieldList.splice(index, 1)
      //this.fieldnames[name_index].value = !this.fieldnames[name_index].value
      console.log(this.fieldList)
      this.update_data('fieldList')
    },
    set_data () {
      const { fieldList, customFieldList } = JSON.parse(JSON.stringify(this.dataVal))
      this.fieldList = fieldList
      this.customFieldList = customFieldList
      console.log('setting data', this.dataVal)
    },
    update_field () {
      const resultArray = []
      this.customFieldList.map((custom_field, index) => {
        const input = this.$refs[`customfield${index}`][0].getInputState()
        resultArray.push(input)
      })
      console.log('res array', resultArray)
      return resultArray
    },
    update_data (ref) {
      const customList = this.update_field()
      this.update(this.fieldList, customList)
      this.$store.commit('SET_EDITING_NOW', ref)
    }
  }
}
</script>

<style lang="scss">
</style>
